import { Component } from 'react';
import { connect } from 'react-redux';
import * as GoToWebinarActions from 'ContentData/actions/GoToWebinar';
import * as goToWebinarSelectors from 'ContentData/selectors/goToWebinar';
import { jsx as _jsx } from "react/jsx-runtime";
function makeMapStateToProps() {
  return function mapStateToProps(state, props) {
    const getIsFormEligible = goToWebinarSelectors.makeGetIsFormEligible();
    return {
      isFormEligible: getIsFormEligible(state, props),
      webinars: goToWebinarSelectors.getWebinars(state)
    };
  };
}
const mapDispatchToProps = {
  fetchEligibleForms: GoToWebinarActions.fetchEligibleForms,
  fetchFutureWebinars: GoToWebinarActions.fetchFutureWebinars
};
export default function withGoToWebinarResource(WrappedComponent) {
  class WithGoToWebinarResource extends Component {
    componentDidMount() {
      this.props.fetchEligibleForms();
      this.props.fetchFutureWebinars();
    }
    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props));
    }
  }
  return connect(makeMapStateToProps, mapDispatchToProps)(WithGoToWebinarResource);
}